import { PAGE_STORAGE_KEY } from "lib/theme";

/** Normalize pathname: strip trailing slashes (except root). */
export function normalizePath(pathname: string): string {
  if (!pathname || pathname === "/") return "/";
  return pathname.replace(/\/+$/, "") || "/";
}

/** URL path → Redux `page` id for section routes. */
export const PATH_TO_PAGE: Record<string, string> = {
  "/support": "support",
  "/demos": "demos",
  "/more-tools": "more-tools",
  "/offers": "trending",
  "/manage-tools": "manage-tools",
  "/login": "manage-tools",
  "/manage": "manage-tools",
  "/toolkit": "more-tools",
};

/** Canonical path for a section `page` id (for redirects / aliases). */
export const PAGE_TO_PATH: Record<string, string> = {
  support: "/support",
  demos: "/demos",
  "more-tools": "/more-tools",
  trending: "/offers",
  "manage-tools": "/manage-tools",
};

export const GUIDE_TAB_PARAMS = new Set([
  "activation",
  "activate",
  "unsubscribe",
  "tg-explore",
  "tg-explorer",
]);

/** Map URL tab aliases → FrontPageTabs id. */
export function normalizeGuideTab(
  tabParam: string | null | undefined,
): "activate" | "unsubscribe" | "tg-explore" | null {
  if (!tabParam) return null;
  switch (tabParam) {
    case "activation":
    case "activate":
      return "activate";
    case "unsubscribe":
      return "unsubscribe";
    case "tg-explore":
    case "tg-explorer":
      return "tg-explore";
    default:
      return null;
  }
}

export function pageFromPathname(pathname: string): string | null {
  return PATH_TO_PAGE[normalizePath(pathname)] ?? null;
}

/** Resolve page for first paint / store hydrate from the current URL. */
export function resolvePageFromLocation(
  pathname: string = typeof window !== "undefined" ? window.location.pathname : "/",
  search: string = typeof window !== "undefined" ? window.location.search : "",
): string {
  const fromPath = pageFromPathname(pathname);
  if (fromPath) return fromPath;

  const path = normalizePath(pathname);
  if (path !== "/") return "front";

  const params = new URLSearchParams(search);
  const tabParam = params.get("tab") ?? params.get("tabs");
  if (normalizeGuideTab(tabParam)) return "front";

  try {
    const stored = localStorage.getItem(PAGE_STORAGE_KEY);
    if (stored) return stored;
  } catch {
    /* ignore */
  }
  return "front";
}

export function persistPage(page: string) {
  try {
    localStorage.setItem(PAGE_STORAGE_KEY, page);
  } catch {
    /* ignore */
  }
}
